/* eslint-disable */
import Ace from 'ace-builds';

// HTML mode
Ace.config.setModuleUrl(
  'ace/mode/html',
  require('file-loader?outputPath=js&esModule=false!ace-builds/src-noconflict/mode-html.js')
);
Ace.config.setModuleUrl(
  'ace/mode/html_worker',
  require('file-loader?outputPath=js&esModule=false!ace-builds/src-noconflict/worker-html.js')
);

// JavaScript mode
Ace.config.setModuleUrl(
  'ace/mode/javascript',
  require('file-loader?outputPath=js&esModule=false!ace-builds/src-noconflict/mode-javascript.js')
);
Ace.config.setModuleUrl(
  'ace/mode/javascript_worker',
  require('file-loader?outputPath=js&esModule=false!ace-builds/src-noconflict/worker-javascript.js')
);

// Chrome theme
Ace.config.setModuleUrl(
  'ace/theme/chrome',
  require('file-loader?outputPath=js&esModule=false!ace-builds/src-noconflict/theme-chrome.js')
);

export default Ace;
